import { render } from "./index.vue?vue&type=template&id=f71bfdba&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=f71bfdba&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/sms-166dx-web-frontend-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f71bfdba"]])

export default __exports__